import React from "react";

function Footer() {
  return (
    <>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0" style={{ textAlign: "center" }}>
          2014 - {new Date().getFullYear()} © PINE.
        </p>
      </div>
    </>
  );
}

export default Footer;
